// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lo que va tarde, en el dashboard del cliente (20-oct-2026). Ver AttentionCard.tsx. */

.AttentionCard_card__F8LLA {
  position: relative;
  overflow: hidden;
}
/* El color de la esquina dice el estado antes de leer: verde si todo va bien, rojo si algo va tarde. */
.AttentionCard_card__F8LLA::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.AttentionCard_calm__QoEV7::before {
  background: radial-gradient(140% 80% at 100% 0%, color-mix(in srgb, #22a04a 12%, transparent) 0%, transparent 55%);
}
.AttentionCard_alert__Od-qB::before {
  background: radial-gradient(140% 80% at 100% 0%, color-mix(in srgb, #ef4444 13%, transparent) 0%, transparent 55%);
}
.AttentionCard_card__F8LLA > * {
  position: relative;
}

.AttentionCard_count__NI6I4 {
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: #ef4444;
  box-shadow: 0 0 0 4px color-mix(in srgb, #ef4444 20%, transparent);
}

/* ============================ Todo bien ============================ */

.AttentionCard_ok__eU8xt {
  display: flex;
  align-items: center;
  gap: 12px;
}
.AttentionCard_okIcon__52tE0 {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #22a04a;
  background: color-mix(in srgb, #22a04a 16%, transparent);
}
.AttentionCard_okTitle__yURm3 {
  margin: 0 0 2px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--dylo-ink);
}
.AttentionCard_okText__iGQyi {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--dylo-muted);
}

/* ============================ Retrasos ============================= */

.AttentionCard_list__mR6Pe {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.AttentionCard_row__WtRBW {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
  background: color-mix(in srgb, var(--sev) 7%, transparent);
  transition: background-color 0.15s ease;
}
.AttentionCard_row__WtRBW:hover,
.AttentionCard_row__WtRBW:focus-visible {
  background: color-mix(in srgb, var(--sev) 14%, transparent);
}

.AttentionCard_main__LS\\+Js {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.AttentionCard_ref__kwpT5 {
  font-size: 13px;
  font-weight: 700;
  color: var(--dylo-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AttentionCard_route__1HOtM {
  font-size: 11.5px;
  color: var(--dylo-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Letra con la tinta normal y el color en el fondo y el punto: el ámbar como letra no se lee sobre claro. */
.AttentionCard_late__6RChf {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  color: var(--dylo-ink);
  background: color-mix(in srgb, var(--sev) 20%, transparent);
}
.AttentionCard_late__6RChf::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--sev);
}

.AttentionCard_more__lBJqE {
  display: inline-block;
  margin-top: 10px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-orange);
  text-decoration: none;
}
.AttentionCard_more__lBJqE:hover {
  text-decoration: underline;
}

@media (prefers-reduced-motion: reduce) {
  .AttentionCard_row__WtRBW {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/AttentionCard.module.css"],"names":[],"mappings":"AAAA,uFAAuF;;AAEvF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,uGAAuG;AACvG;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,kHAAkH;AACpH;AACA;EACE,kHAAkH;AACpH;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA,wEAAwE;;AAExE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,wEAAwE;;AAExE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,0DAA0D;EAC1D,uCAAuC;AACzC;AACA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4GAA4G;AAC5G;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Lo que va tarde, en el dashboard del cliente (20-oct-2026). Ver AttentionCard.tsx. */\n\n.card {\n  position: relative;\n  overflow: hidden;\n}\n/* El color de la esquina dice el estado antes de leer: verde si todo va bien, rojo si algo va tarde. */\n.card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n.calm::before {\n  background: radial-gradient(140% 80% at 100% 0%, color-mix(in srgb, #22a04a 12%, transparent) 0%, transparent 55%);\n}\n.alert::before {\n  background: radial-gradient(140% 80% at 100% 0%, color-mix(in srgb, #ef4444 13%, transparent) 0%, transparent 55%);\n}\n.card > * {\n  position: relative;\n}\n\n.count {\n  min-width: 24px;\n  height: 24px;\n  padding: 0 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  background: #ef4444;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #ef4444 20%, transparent);\n}\n\n/* ============================ Todo bien ============================ */\n\n.ok {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.okIcon {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  color: #22a04a;\n  background: color-mix(in srgb, #22a04a 16%, transparent);\n}\n.okTitle {\n  margin: 0 0 2px;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.okText {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--dylo-muted);\n}\n\n/* ============================ Retrasos ============================= */\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  color: inherit;\n  text-decoration: none;\n  background: color-mix(in srgb, var(--sev) 7%, transparent);\n  transition: background-color 0.15s ease;\n}\n.row:hover,\n.row:focus-visible {\n  background: color-mix(in srgb, var(--sev) 14%, transparent);\n}\n\n.main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.ref {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.route {\n  font-size: 11.5px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Letra con la tinta normal y el color en el fondo y el punto: el ámbar como letra no se lee sobre claro. */\n.late {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, var(--sev) 20%, transparent);\n}\n.late::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--sev);\n}\n\n.more {\n  display: inline-block;\n  margin-top: 10px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-orange);\n  text-decoration: none;\n}\n.more:hover {\n  text-decoration: underline;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .row {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `AttentionCard_card__F8LLA`,
	"calm": `AttentionCard_calm__QoEV7`,
	"alert": `AttentionCard_alert__Od-qB`,
	"count": `AttentionCard_count__NI6I4`,
	"ok": `AttentionCard_ok__eU8xt`,
	"okIcon": `AttentionCard_okIcon__52tE0`,
	"okTitle": `AttentionCard_okTitle__yURm3`,
	"okText": `AttentionCard_okText__iGQyi`,
	"list": `AttentionCard_list__mR6Pe`,
	"row": `AttentionCard_row__WtRBW`,
	"main": `AttentionCard_main__LS+Js`,
	"ref": `AttentionCard_ref__kwpT5`,
	"route": `AttentionCard_route__1HOtM`,
	"late": `AttentionCard_late__6RChf`,
	"more": `AttentionCard_more__lBJqE`
};
export default ___CSS_LOADER_EXPORT___;
